<script>
    export let redirectTo;
</script>

    <div class="card shadow" style="border:none;margin-top:100px;">
        <div class="card-body">
            <div style="height:40px"></div>
            <div class="text-center">
                <img src="/df_logo_dark.png" alt="Donorflow" width="80" />
            </div>
            <div style="height:40px"></div>
            <p class="text-center">Please sign into your Donorflow account to continue.</p>
            <div style="height:40px"></div>
            <div class="text-center">
                <a href={`https://app.donorflow.net/login?redirectTo=${redirectTo}`} class="btn btn-primary text-white shadow btn-block">Sign in</a>
            </div>
            <div style="height:20px"></div>
        </div>
    </div>
    <div style="height:60px"></div>
    <p class="text-center text-muted" style="font-size:0.8rem;">&copy; 2021 Donorflow AB.</p>